module.exports = __webpack_public_path__ + "static/media/mailgrey.65ccefc8.svg";